export const contract = {
  list: '套餐列表',
  from: '套餐操作',
  info: '套餐费用',

  clause_info: '条款信息',

  type: '套餐类型',
  chinese_title: '套餐中文名称',
  english_title: '套餐英文名称',
  virtual_product_no: '虚拟商品编号',
  china_apple_product_no: '中国区苹果商品编号',
  other_apple_product_no: '其他区苹果商品编号',
  description: '套餐描述',
  content: '套餐详情',
  money: '套餐金额',
  chinese_money: '套餐金额(人民币)',
  english_money: '套餐金额(美元)',
  pay_money: '支付金额',
  chinese_pay_money: '支付金额(人民币)',
  english_pay_money: '支付金额(美元)',
  original_money: '原始价格',
  period: '有效周期(月)',
  value: '套餐天数',
  rate: '优惠折扣',

  rules: {
    chinese_title: {
      require: '套餐中文名称不能为空',
    },
    english_title: {
      require: '套餐英文名称不能为空',
    },
    virtual_product_no: {
      require: '虚拟商品编号不能为空',
    },
    china_apple_product_no: {
      require: '中国区苹果商品编号不能为空',
    },
    other_apple_product_no: {
      require: '其他区苹果商品编号不能为空',
    },
    chinese_money: {
      require: '套餐金额(人民币)不能为空',
    },
    chinese_pay_money: {
      require: '支付金额(人民币)不能为空',
    },
    original_money: {
      require: '原始价格不能为空',
    },
    period: {
      require: '套餐周期不能为空',
    },
    value: {
      require: '套餐天数不能为空',
    },
  },

  // 套餐赠品
  gift: {
    info: '赠送信息',

    type: '赠送类型',
    month: '赠送月数',
    day: '赠送天数',

    rules: {
      type: {
        require: '赠送类型不能为空',
      },
    },
  },

  // 套餐分类
  category: {
    list: '套餐分类列表',
    from: '套餐分类操作',

    picture: '套餐分类图片',
    chinese_title: '分类中文标题',
    english_title: '分类英文标题',

    rules: {
      picture: {
        require: '套餐分类图片不能为空',
      },
      chinese_title: {
        require: '分类中文标题不能为空',
      },
      english_title: {
        require: '分类英文标题不能为空',
      },
    },
  },

  // 套餐条款
  authority: {
    list: '套餐权益列表',
    from: '套餐权益操作',
    info: '套餐权益',

    picture: '套餐权益图片',
    chinese_title: '权益中文标题',
    english_title: '权益英文标题',

    rules: {
      picture: {
        require: '套餐权益图片不能为空',
      },
      chinese_title: {
        require: '权益中文标题不能为空',
      },
      english_title: {
        require: '权益英文标题不能为空',
      },
    },
  },

  // 套餐条款
  clause: {
    list: '套餐条款列表',
    from: '套餐条款操作',
    info: '条款',

    chinese_name: '条款中文名称',
    english_name: '条款英文名称',
    title: '条款标题',
    value: '条款内容',
    chinese_description: '条款中文说明',
    english_description: '条款英文说明',

    rules: {
      chinese_name: {
        require: '条款中文名称不能为空',
      },
      english_name: {
        require: '条款英文名称不能为空',
      },
      title: {
        require: '条款标题不能为空',
      },
      value: {
        require: '条款内容不能为空',
      },
    },
  },

  refuel: {
    list: '加油包列表',
    from: '加油包操作',

    type: '加油包类型',
    chinese_title: '加油包中文名称',
    english_title: '加油包英文名称',
    money: '加油包费用',
    chinese_money: '加油包费用(人民币)',
    english_money: '加油包费用(美元)',
    once_money: '单次费用',
    chinese_once_money: '单次费用(人民币)',
    english_once_money: '单次费用(美元)',
    inquiry_publish_total: '询价发布次数',
    schedule_search_total: '船期查询次数',
    is_discount: '首充福利',

    rules: {
      type: {
        require: '加油包类型不能为空',
      },
      chinese_title: {
        require: '加油包中文名称不能为空',
      },
      english_title: {
        require: '加油包英文名称不能为空',
      },
      chinese_money: {
        require: '加油包金额(人民币)不能为空',
      },
      chinese_once_money: {
        require: '单次费用(人民币)不能为空',
      },
    },
  }
}
